import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  greaseAnswers: {}
};

const greaseAnswersSlice = createSlice({
  name: "greaseAnswers",
  initialState,
  reducers: {
    setGreaseAnswer(state, action) {
      const { questionId, answers } = action.payload;
      state.greaseAnswers[questionId] = answers;
    },
  }
});

export const { setGreaseAnswer, clearGreaseAnswer } =
  greaseAnswersSlice.actions;

export default greaseAnswersSlice.reducer;
